/* eslint-disable import/no-anonymous-default-export */
export default {
  BASE_URL:
    process.env.REACT_APP_API_URL || "https://pedlar-dev.ts.r.appspot.com"
};
